
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".622","y":".555","width":"15","height":"11","rx":"1.5","stroke":"#000C1F","stroke-dasharray":"4 4"}}),_c('path',{attrs:{"d":"M8.198 20.25a.118.118 0 01-.076.023.147.147 0 01-.076-.017.095.095 0 01-.041-.059.324.324 0 01-.024-.082l-.017-.129a1.705 1.705 0 00-.398-.95 1.154 1.154 0 00-.727-.427 1.933 1.933 0 00-.352-.023H3.874c-.414 0-.742-.1-.984-.299-.266-.215-.46-.515-.58-.902a3.671 3.671 0 01-.188-1.12c0-.144.045-.214.135-.21.039 0 .068.011.088.035.02.023.033.056.04.1.009.042.016.091.024.146l.03.187c.011.07.025.137.04.2.223.68.665 1.02 1.325 1.02h2.7c.84 0 1.38.476 1.618 1.429.238-.953.754-1.43 1.547-1.43h2.666c.191 0 .336-.008.434-.023.273-.055.51-.205.708-.451.2-.25.319-.559.358-.926.023-.192.074-.287.152-.287.09 0 .135.066.135.199a3.22 3.22 0 01-.37 1.54c-.241.462-.595.722-1.06.78a3.773 3.773 0 01-.345.012H9.716c-.266 0-.498.055-.697.164-.2.105-.346.238-.44.398-.098.16-.168.301-.21.422a1.75 1.75 0 00-.089.323 1.386 1.386 0 01-.017.21.612.612 0 01-.018.082.162.162 0 01-.047.065z","fill":"#000C1F"}})])
          )
        }
      }
    